import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';

export interface ImageText {
  productName: string;
  shortText: string;
}
interface Props {
  image: ImageProps;
  text?: ImageText;
}

const ImageAndText = ({ image, text }: Props) => {
  return (
    <div key={image?.image?.id} className="flex align-center flex-col text-center">
      <LazyLoadImage
        imgComponent={
          /* eslint-disable-next-line @next/next/no-img-element */
          <img src={buildImageSrc(image, 1, 1, 1)} alt={image.altTag} height="100%" width="auto" />
        }
      />
      {text && (
        <div className="pt-5">
          {text?.productName && (
            <p className="text-warm-400 mb-0 tra-text-heading-h5">{text.productName}</p>
          )}
          {text?.shortText && (
            <p className="text-neutral-100 mb-0 tra-text-web-body-xl">{text.shortText}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageAndText;
